import ContactAccordion from 'src/components/HelpInfo/ContactAccordion';
import AccordionList from 'src/components/HelpInfo/AccordionList';
import ContactImportance from 'src/components/HelpInfo/ContactImportance';

const BusinessHelpInfo = () => {
  return (
    <>
      <AccordionList
        accordions={[
          <ContactAccordion key="contactAccordion" />,
          <ContactImportance key="contactImportance" />,
        ]}
      />
    </>
  );
};

export default BusinessHelpInfo;
